import { render, staticRenderFns } from "./create_report2.vue?vue&type=template&id=b1e0cc50&scoped=true"
import script from "./create_report2.vue?vue&type=script&lang=js"
export * from "./create_report2.vue?vue&type=script&lang=js"
import style0 from "./create_report2.vue?vue&type=style&index=0&id=b1e0cc50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1e0cc50",
  null
  
)

export default component.exports